export default "__VITE_ASSET__RQ6Bafyi__"